var map = {
	"./ai.png": "5e7b",
	"./appointment.png": "1f47",
	"./article.png": "255f",
	"./emr.png": "2769",
	"./excretion.png": "575c",
	"./exercise.png": "fbbd",
	"./facesheet.png": "c089",
	"./food.png": "c1f0",
	"./medication.png": "c7fc",
	"./message.png": "7f98",
	"./no_patient.png": "e0807",
	"./questionnaire.png": "b6b2",
	"./schedule.png": "3f2c",
	"./symptom.png": "1144",
	"./vital.png": "e71c",
	"./water.png": "56b8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "65bf";